import React from 'react';
import { Redirect } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';

const EmailLogin = () => {
  const [emailLoginToken] = useQueryParam('token', StringParam);

  return (
    <Redirect
      to={{
        pathname: '/login',
        search: `emailLoginToken=${emailLoginToken}`,
      }}
    />
  );
};

export default EmailLogin;
